import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Popconfirm, Table, Row, Col } from 'antd';


const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
        
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};
const HouseResources = () => {
    const [dataSource, setDataSource] = useState([
        {
            key: '0',
            name: 'Company Name',
            utilitytype: 'Primary Mortgage',
            amount: '$9999',
        },
        {
            key: '1',
            name: 'Company Name',
            utilitytype: 'Second Mortgage',
            amount: '$9999',
        },
        {
            key: '2',
            name: 'Company Name',
            utilitytype: 'Bank Account',
            amount: '$9999',
        },
        {
            key: '3',
            name: 'Company Name',
            utilitytype: 'Credit Card',
            amount: '$9999',
        },
        {
            key: '4',
            name: 'Company Name',
            utilitytype: 'Primary Mortgage',
            amount: '$9999',
        },
        {
            key: '5',
            name: 'Company Name',
            utilitytype: 'Primary Mortgage',
            amount: '$9999',
        },
        {
            key: '6',
            name: 'Company Name',
            utilitytype: 'Primary Mortgage',
            amount: '$9999',
        },
        {
            key: '7',
            name: 'Company Name',
            utilitytype: 'Primary Mortgage',
            amount: '$9999',
        },
        {
            key: '8',
            name: 'Company Name',
            utilitytype: 'Primary Mortgage',
            amount: '$9999',
        },

    ]);
    const [count, setCount] = useState(2);
    const [pagesize, setPageSize] = useState(5);
    const [current, setCurrent] = useState(1);
   
    const defaultColumns = [
        {
            title: 'Utility Company Name',
            dataIndex: 'name',
            width: '30%',
            editable: true,
        },
        {
            title: 'Utility Type',
            dataIndex: 'utilitytype',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
        },
    ];
    const handleAdd = () => {
        const newData = {
            key: count,
            name: `Edward King ${count}`,
            age: '32',
            address: `London, Park Lane no. ${count}`,
        };
        setDataSource([...dataSource, newData]);
        setCount(count + 1);
    };
    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    };
    const Components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <>
            <div>
                <div className='overlayGroup financeProviderHeader'>
                    <Row>
                        <Col md={12} className='leftSection'>
                            <div className='bluwBannersection'>
                                <div className='blueBanner'>
                                    <h5>House Resource</h5>
                                </div>
                                <div className='infoText'>
                                    <p>Property Profile</p>
                                    <span>Uptown Sedona - 123 abbot st.</span>
                                </div>
                            </div>
                        </Col>
                        <Col md={12} className='RightSection text-end'>
                            <div className='header-imgSection'>
                                <div className='image pt-1'>
                                    <img class="img-fluid" src="assets/images/house-resource.png" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="custom-table-container create-user mt-4 financeProviderTable">
                    <Table
                        Components={Components}
                        rowClassName={() => 'editable-row'}
                        bordered
                        dataSource={dataSource}
                        columns={columns}
                        pagination={
                            dataSource.length > 0 && dataSource.length >= 5
                                ? {
                                    total: 10,
                                    pageSize: pagesize,
                                    onChange: (page, pageSize) => {
                                        setPageSize(pageSize);
                                        setCurrent(page);
                                    },
                                    showSizeChanger: false,
                                    pageSizeOptions: ['5', '10', '20', '30', '50'],
                                    locale: {
                                        items_per_page: `/${10 || 0} Records`,
                                    },
                                }
                                : ''
                                
                        }
                    />
                </div>
            </div>
        </>
    );
};
export default HouseResources;